import { useEffect, useState } from "react";
import { Row, Col, Carousel, Modal, Button } from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import GNavbar from '../../components/navbar';

import NewWallpaperIcon from '../../assets/images/new_wallpaper_icon.png'
import FreeWallpaperIcon from '../../assets/images/free_wallpaper_icon.png'
import ComingSoonWallpaperIcon from '../../assets/images/cms_wallpaper_icon.png'
import DiscountWallpaperIcon from '../../assets/images/pro_wallpaper_icon.png'

import CarouselPromotion from "../../components/carousel-promotion";

function WallpaperShop() {

    let { lineId } = useParams();

    let navigate = useNavigate();

    const [wallpaperCategories, setWallpaperCategories] = useState([
        {
            "cate_id": 1,
            "name": "วอลเปเปอร์มงคล เสริมดวง!",
            "wall_cat_order": 3,
            "description": "วอลเปเปอร์เสริมดวงสำหรับชาวเกษตร รวย เฮง ปัง! ของขวัญสุดพิเศษจาก DIN Platform",
            "active": 1,
            "wallpapers": [
                {
                    "wid": 37,
                    "name": "ยันต์โสฬส มงคลทั่วจักรวาล เสริมบารมี โชคลาภ",
                    "price": 199,
                    "description": "",
                    "short_description": "โชคลาภ ความมั่นคง ทรัพย์สมบัติ",
                    "thumbnail_img": "https://ganesha168.sgp1.digitaloceanspaces.com/wallpapers/thumbnail_img/thumb-yan-1.jpg",
                    "active": 1,
                    "show": 1,
                    "status": 2,
                    "wall_order": 1,
                    "type": null,
                    "config": null,
                    "categories_id": 1
                },
                {
                    "wid": 38,
                    "name": "จัตุโรบังเกิดทรัพย์คับ เงินทอง โชคลาภ เน้น ๆ",
                    "price": 199,
                    "description": "",
                    "short_description": "โชคลาภ ความมั่นคง ทรัพย์สมบัติ",
                    "thumbnail_img": "https://ganesha168.sgp1.digitaloceanspaces.com/wallpapers/thumbnail_img/thumb-yan-2.jpg",
                    "active": 1,
                    "show": 1,
                    "status": 2,
                    "wall_order": 2,
                    "type": null,
                    "config": null,
                    "categories_id": 1
                }
            ]
        }
    ])

    const handleClickWallpaper = (e) => {
        navigate("/wallpaper/item/" + e.target.id, {
            state: {
                "line_id": lineId
            }
        })
    }

    useEffect(() => {

    }, []);


    return (
        <>
            <div className="wallpaperBg">
                <div className="wallpaperBox">
                    {
                        wallpaperCategories.map((category) => {
                            if (category.active === 1) {
                                return (
                                    <div key={category.cate_id}>
                                        <h3 className="wallpaperCategoryHeader">{category.name}</h3>
                                        <p style={{ color: '#2c3e50', textAlign: 'center' }}>{category.description}</p>
                                        <Row>
                                            {
                                                category.wallpapers.map((wallpaper) => {
                                                    if (wallpaper.show !== 0) {
                                                        return (
                                                            <Col key={wallpaper.wid} xs="6" className="wallpaperContainer" onClick={handleClickWallpaper}>
                                                                <img id={wallpaper.wid} src={wallpaper.thumbnail_img} className={wallpaper.active === 1 ? "wallpaperThumbnail" : "wallpaperThumbnailNotActive"} />
                                                                {wallpaper.status === 1 && <img src={NewWallpaperIcon} id={wallpaper.wid} className="wallpaperNewIcon" />}
                                                                {wallpaper.status === 2 && <img src={FreeWallpaperIcon} id={wallpaper.wid} className="wallpaperNewIcon" />}
                                                                {wallpaper.status === 3 && <img src={ComingSoonWallpaperIcon} id={wallpaper.wid} className="wallpaperNewIcon" />}
                                                                {wallpaper.status === 4 && <img src={DiscountWallpaperIcon} id={wallpaper.wid} className="wallpaperNewIcon" />}
                                                                <div id={wallpaper.wid} className="wallpaperOverlay">{wallpaper.name}</div>
                                                            </Col>
                                                        )
                                                    }
                                                })
                                            }
                                        </Row>
                                    </div>
                                )
                            }
                        })
                    }
                    {/* <Row>
                        {
                            wallpapers.map((wallpaper) => {
                                return (
                                    <Col key={wallpaper.wid} xs="6" className="wallpaperContainer" onClick={handleClickWallpaper}>
                                        <img id={wallpaper.wid} src={wallpaper.thumbnail_img} className={wallpaper.active === 1 ? "wallpaperThumbnail" : "wallpaperThumbnailNotActive"} />
                                        {wallpaper.status === 1 && <img src={NewWallpaperIcon} className="wallpaperNewIcon" />}
                                        {wallpaper.status === 2 && <img src={FreeWallpaperIcon} className="wallpaperNewIcon" />}
                                        {wallpaper.status === 3 && <img src={ComingSoonWallpaperIcon} className="wallpaperNewIcon" />}
                                        {wallpaper.status === 4 && <img src={DiscountWallpaperIcon} className="wallpaperNewIcon" />}
                                        <div id={wallpaper.wid} className="wallpaperOverlay">{wallpaper.name}</div>
                                    </Col>
                                )
                            })
                        }
                    </Row> */}
                </div>
            </div>
        </>
    )
}

export default WallpaperShop;